<template>
	<AppButton
		variant="primary"
		:accent-color="accentColor"
		:border="border"
		:size="size"
		:is-outline="isOutline"
		:is-soft="isSoft"
		:is-icon-only="isIconOnly"
		:is-active="isActive"
		:is-toggle="isToggle"
		:is-disabled="isDisabled"
		:is-loading="isLoading"
		:is-ripple="isRipple"
		:label="label"
		v-bind="$attrs"
	>
		<slot />
	</AppButton>
</template>

<script>
import AppButton from '../AppButton.vue'
import { mapGetters } from 'vuex'

export default {
	name: 'PrimaryButton',
	components: { AppButton },
	props: {
		/** Color del botón (ej. #11283d). Si se pasa, sobrescribe --bs-primary. En el futuro puede venir del store. */
		accentColor: { type: String, default: "" },
		size: String,
		isOutline: Boolean,
		isSoft: Boolean,
		isIconOnly: Boolean,
		isActive: Boolean,
		isToggle: Boolean,
		isDisabled: Boolean,
		isLoading: Boolean,
		isRipple: {
			type: Boolean,
			default: true
		},
		label: {
			type: String,
			default: ''
		}
	},
	computed: {
		...mapGetters('ui', ['buttonBorder']),
		border() {
			return this.buttonBorder || 'rounded'
		}
	}
}
</script>
